<template>
  <v-dialog ref="dialog" v-model="dialog" persistent width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :class="classes"
        :disabled="disabled"
        :label="label"
        :rules="rules"
        :value="$formatDateNoTime(value)"
        readonly
        v-bind="{ ...$attrs, ...attrs }"
        v-on="on"
        @click:append="on.click"
      ></v-text-field>
    </template>
    <v-date-picker v-model="innerValue" color="primary" first-day-of-week="1" light locale="fi-fi" scrollable>
      <v-btn text @click="dialog = false">{{ $t('cancel') }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" elevation="0" @click="handleDateChange">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'DateField',
  props: ['value', 'label', 'disabled', 'classes', 'rules'],
  data() {
    return {
      dialog: false,
      innerValue: null,
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.innerValue = dayjs(this.value || dayjs().toISOString()).format('YYYY-MM-DD');
      }
    },
  },
  methods: {
    handleDateChange() {
      this.dialog = false;
      this.$emit('input', dayjs(this.innerValue).format('YYYY-MM-DD'));
    },
  },
};
</script>

<style scoped></style>
